import { InjectionToken, Component, Input, ViewChildren, Pipe, Directive, ElementRef, Injector, HostListener, NgModule } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentErrorHandler } from '@mt-ng2/component-error-handler';
import { format } from '@mt-ng2/format-functions';
import { getPrimary } from '@mt-ng2/common-functions';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/**
 * Token used for providing the IMtPhoneConfig
 * @example
 * // in the app or shared modules providers section
 * providers: [
 *     { provide: MtPhoneModuleConfigToken, useValue: mtPhoneModuleConfig },
 * ],
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@ng-bootstrap/ng-bootstrap';

const _c0 = ["input"];
const _c1 = function (a0) { return { "fa-check": a0 }; };
function MtPhoneComponent_ngb_panel_7_li_17_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 26);
    ɵngcc0.ɵɵlistener("click", function MtPhoneComponent_ngb_panel_7_li_17_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const phoneType_r6 = ctx.$implicit; const i_r3 = ɵngcc0.ɵɵnextContext().index; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.setPhoneType(i_r3, phoneType_r6.Id); });
    ɵngcc0.ɵɵtext(1, "\n                                            ");
    ɵngcc0.ɵɵelementStart(2, "a", 27);
    ɵngcc0.ɵɵtext(3, "\n                                                ");
    ɵngcc0.ɵɵelement(4, "i", 28);
    ɵngcc0.ɵɵtext(5, "\n                                                ");
    ɵngcc0.ɵɵelement(6, "span");
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(8, "\n                                        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const phoneType_r6 = ctx.$implicit;
    const phone_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c1, phone_r2.value.PhoneTypeId === phoneType_r6.Id));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassMapInterpolate1("fa fa-no-margin-right fa-", ctx_r4.phoneTypeClass(phoneType_r6.Id), "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0\n                                                ", phoneType_r6.Name, "");
} }
const _c2 = function (a0) { return { "has-error": a0 }; };
const _c3 = function (a0) { return { selected: a0 }; };
function MtPhoneComponent_ngb_panel_7_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngb-panel", 5);
    ɵngcc0.ɵɵtext(1, "\n                        ");
    ɵngcc0.ɵɵelementStart(2, "div", 6);
    ɵngcc0.ɵɵtext(3, "\n                            ");
    ɵngcc0.ɵɵelementStart(4, "span", 7);
    ɵngcc0.ɵɵtext(5, "\n                                ");
    ɵngcc0.ɵɵelementStart(6, "span", 8);
    ɵngcc0.ɵɵtext(7, "\n                                    ");
    ɵngcc0.ɵɵelementStart(8, "button", 9);
    ɵngcc0.ɵɵtext(9, "\n                                        ");
    ɵngcc0.ɵɵelement(10, "i");
    ɵngcc0.ɵɵtext(11, "\n                                        ");
    ɵngcc0.ɵɵelement(12, "span", 10);
    ɵngcc0.ɵɵtext(13, "\n                                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(14, "\n                                    ");
    ɵngcc0.ɵɵelementStart(15, "ul", 11);
    ɵngcc0.ɵɵtext(16, "\n                                        ");
    ɵngcc0.ɵɵtemplate(17, MtPhoneComponent_ngb_panel_7_li_17_Template, 9, 7, "li", 12);
    ɵngcc0.ɵɵtext(18, "\n                                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(19, "\n                                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(20, "\n                            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(21, "\n                            ");
    ɵngcc0.ɵɵelementStart(22, "div", 13);
    ɵngcc0.ɵɵtext(23, "\n                                ");
    ɵngcc0.ɵɵelementStart(24, "div", 14);
    ɵngcc0.ɵɵtext(25, "\n                                    ");
    ɵngcc0.ɵɵelement(26, "input", 15, 16);
    ɵngcc0.ɵɵtext(28, "\n                                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(29, "\n                                ");
    ɵngcc0.ɵɵelementStart(30, "div", 17);
    ɵngcc0.ɵɵtext(31, "\n                                    ");
    ɵngcc0.ɵɵelementStart(32, "div", 18);
    ɵngcc0.ɵɵtext(33, "\n                                        ");
    ɵngcc0.ɵɵelementStart(34, "span", 19);
    ɵngcc0.ɵɵtext(35, "Ext:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(36, "\n                                        ");
    ɵngcc0.ɵɵelement(37, "input", 20);
    ɵngcc0.ɵɵtext(38, "\n                                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(39, "\n                                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(40, "\n                            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(41, "\n                            ");
    ɵngcc0.ɵɵelementStart(42, "span", 7);
    ɵngcc0.ɵɵtext(43, "\n                                ");
    ɵngcc0.ɵɵelementStart(44, "button", 21);
    ɵngcc0.ɵɵlistener("click", function MtPhoneComponent_ngb_panel_7_Template_button_click_44_listener() { ɵngcc0.ɵɵrestoreView(_r12); const i_r3 = ctx.index; const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.setPhonePref(i_r3); });
    ɵngcc0.ɵɵtext(45, "\n                                    ");
    ɵngcc0.ɵɵelement(46, "i", 22);
    ɵngcc0.ɵɵtext(47, "\n                                    ");
    ɵngcc0.ɵɵelement(48, "i", 23);
    ɵngcc0.ɵɵtext(49, "\n                                    ");
    ɵngcc0.ɵɵelement(50, "i", 22);
    ɵngcc0.ɵɵtext(51, "\n                                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(52, "\n                            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(53, "\n                            ");
    ɵngcc0.ɵɵelementStart(54, "span", 7);
    ɵngcc0.ɵɵtext(55, "\n                                ");
    ɵngcc0.ɵɵelementStart(56, "button", 24);
    ɵngcc0.ɵɵlistener("click", function MtPhoneComponent_ngb_panel_7_Template_button_click_56_listener() { ɵngcc0.ɵɵrestoreView(_r12); const i_r3 = ctx.index; const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.removePhone(i_r3); });
    ɵngcc0.ɵɵtext(57, "\n                                    ");
    ɵngcc0.ɵɵelement(58, "i", 22);
    ɵngcc0.ɵɵtext(59, "\n                                    ");
    ɵngcc0.ɵɵelement(60, "i", 25);
    ɵngcc0.ɵɵtext(61, "\n                                    ");
    ɵngcc0.ɵɵelement(62, "i", 22);
    ɵngcc0.ɵɵtext(63, "\n                                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(64, "\n                            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(65, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(66, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const phone_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formArrayName", i_r3);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵclassMapInterpolate1("fa fa-fw fa-", ctx_r0.phoneTypeClass(phone_r2.value.PhoneTypeId), "");
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.PhoneTypes);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c2, ctx_r0.parentForm.get("phones")["controls"][i_r3].touched && ctx_r0.parentForm.get("phones")["controls"][i_r3].dirty && !ctx_r0.parentForm.get("phones")["controls"][i_r3].valid));
    ɵngcc0.ɵɵadvance(20);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c3, phone_r2.value.IsPrimary));
} }
function MtPhoneComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "button", 30);
    ɵngcc0.ɵɵlistener("click", function MtPhoneComponent_div_11_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.addEmptyPhone(); });
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵelement(4, "i", 31);
    ɵngcc0.ɵɵtext(5, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} }
const MtPhoneModuleConfigToken = new InjectionToken('phone_module_config');

const DefaultPhoneTypes = [
    {
        IconFaClass: 'home',
        Id: 1,
        Name: 'Home',
    },
    {
        IconFaClass: 'phone',
        Id: 2,
        Name: 'Work',
    },
    {
        IconFaClass: 'mobile',
        Id: 3,
        Name: 'Mobile',
    },
    {
        IconFaClass: 'fax',
        Id: 4,
        Name: 'Fax',
    },
];
class MtPhoneComponent {
    constructor(fb) {
        this.fb = fb;
        this.errorHandler = new ComponentErrorHandler('MtPhoneComponent', '@mt-ng2/phone-control');
        this._PhoneArray = [];
        this.PhoneTypes = DefaultPhoneTypes;
        this.isEditing = true;
        this.canAdd = true;
    }
    get PhoneArray() {
        return this._PhoneArray;
    }
    set PhoneArray(value) {
        this._PhoneArray = value;
        if (this.parentForm) {
            this.loadForm();
        }
    }
    getDefaultPhoneTypeId() {
        if (typeof this.defaultPhoneTypeId !== 'undefined') {
            return this.defaultPhoneTypeId;
        }
        if (this.PhoneTypes === DefaultPhoneTypes) {
            return 2;
        }
        return this.PhoneTypes[0].Id;
    }
    /**
     * Function for flipping the phone icon based on the type
     * of phone it is displaying
     * @param phoneTypeId
     */
    phoneTypeClass(phoneTypeId) {
        var _a;
        let phoneType = this.PhoneTypes.find((pt) => pt.Id === phoneTypeId);
        return (_a = phoneType === null || phoneType === void 0 ? void 0 : phoneType.IconFaClass) !== null && _a !== void 0 ? _a : 'phone';
    }
    newPhone(IsPrimary = false) {
        return {
            Extension: '',
            IsPrimary: IsPrimary,
            Phone: '',
            PhoneTypeId: this.getDefaultPhoneTypeId(),
        };
    }
    ngOnInit() {
        this.loadForm();
    }
    ngAfterViewInit() {
        var _a, _b, _c;
        // focus the element the first time
        if (!this.focusSubscription) {
            (_c = (_b = (_a = this.rows.last) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.focus) === null || _c === void 0 ? void 0 : _c.call(_b);
            // focus on the last item when something changes
            this.focusSubscription = this.rows.changes.subscribe((row) => {
                var _a;
                if ((_a = row.last) === null || _a === void 0 ? void 0 : _a.nativeElement) {
                    row.last.nativeElement.focus();
                }
            });
        }
    }
    ngOnDestroy() {
        if (this.focusSubscription) {
            this.focusSubscription.unsubscribe();
        }
    }
    loadForm() {
        if (!this.parentForm) {
            this.parentForm = this.fb.group({});
        }
        // map individual phones in phone array input as separate form groups
        const phoneFGs = this._PhoneArray
            .sort((a, b) => {
            return b.IsPrimary - a.IsPrimary;
        })
            .map((phone) => this.fb.group(phone));
        const phoneFormArray = this.fb.array(phoneFGs);
        if (phoneFormArray.length === 0) {
            // First phone so show it as primary
            phoneFormArray.push(this.fb.group(this.newPhone(true)));
        }
        if (this.parentForm.contains('phones')) {
            this.parentForm.setControl('phones', phoneFormArray);
        }
        else {
            this.parentForm.addControl('phones', phoneFormArray);
        }
    }
    get phones() {
        return this.parentForm.get('phones');
    }
    get phonesControls() {
        const controlsProperty = 'controls';
        return this.parentForm.get('phones')[controlsProperty];
    }
    setPhoneType(index, type) {
        const phoneArray = this.getPhoneArray();
        if (!phoneArray[index]) {
            this.errorHandler.addError('index parameter in setPhoneType is out of range');
        }
        if (!this.PhoneTypes.find((pt) => pt.Id === type)) {
            this.errorHandler.addError('type parameter in setPhoneType is not a valid phoneTypeId');
        }
        phoneArray[index].PhoneTypeId = type;
        this.parentForm.get('phones').patchValue(phoneArray);
    }
    setPhonePref(index) {
        const phoneArray = this.getPhoneArray();
        if (!phoneArray[index]) {
            this.errorHandler.addError('index parameter in setPhonePref is out of range');
        }
        for (let i = 0; i < phoneArray.length; i++) {
            phoneArray[i].IsPrimary = i === index;
        }
        this.parentForm.get('phones').patchValue(phoneArray);
    }
    removePhone(index) {
        let phoneArray = this.getPhoneArray();
        if (!phoneArray[index]) {
            this.errorHandler.addError('index parameter in removePhone is out of range');
        }
        phoneArray = this.parentForm.get('phones');
        if (phoneArray.at(index).value.IsPrimary) {
        }
        phoneArray.removeAt(index);
        if (phoneArray.length === 0) {
            phoneArray.push(this.fb.group(this.newPhone(true)));
        }
        else {
            phoneArray.at(0).patchValue({ IsPrimary: true });
        }
    }
    addEmptyPhone() {
        if (!this.canAdd) {
            return;
        }
        // This at some point calls setPhoneArray and updating that fixed this issue.
        this.phones.push(this.fb.group(this.newPhone()));
    }
    getPhoneArray() {
        return this.parentForm.get('phones').value;
    }
}
MtPhoneComponent.ɵfac = function MtPhoneComponent_Factory(t) { return new (t || MtPhoneComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FormBuilder)); };
MtPhoneComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MtPhoneComponent, selectors: [["app-mt-phone"]], viewQuery: function MtPhoneComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.rows = _t);
    } }, inputs: { PhoneTypes: "PhoneTypes", canAdd: "canAdd", PhoneArray: "PhoneArray", parentForm: "parentForm", defaultPhoneTypeId: "defaultPhoneTypeId" }, decls: 18, vars: 3, consts: [[1, "form-group"], [3, "formGroup"], ["formGroupName", "phones"], ["type", "info", 4, "ngFor", "ngForOf"], ["class", "fab-wrap", "ng-show", "phoneHover === true", 4, "ngIf"], ["type", "info"], [1, "input-group", 3, "formArrayName"], [1, "input-group-btn"], ["ngbDropdown", "", 1, "dropdown"], ["ngbDropdownToggle", "", "type", "button", 1, "btn", "btn-default", "btn-flat", "dropdown-toggle"], [1, "caret"], ["ngbDropdownMenu", "", 1, "dropdown-menu"], [3, "click", 4, "ngFor", "ngForOf"], [1, "row"], [1, "col-md-8", 2, "padding-right", "0", 3, "ngClass"], ["name", "Phone", "minlength", "10", "type", "tel", "id", "inputPhone", "formControlName", "Phone", "phoneMask", "", 1, "form-control"], ["input", ""], [1, "col-md-4", 2, "padding-left", "0"], [1, "input-group", 2, "width", "100%"], ["id", "ext-addon", 1, "input-group-addon"], ["aria-describedby", "ext-addon", "type", "tel", "name", "ext", "id", "inputExt", "formControlName", "Extension", 1, "form-control"], ["type", "button", 1, "btn", "btn-default", "btn-flat", 3, "ngClass", "click"], [1, "fa"], [1, "fa", "fa-fw", "fa-star"], ["type", "button", 1, "btn", "btn-default", "btn-flat", 3, "click"], [1, "fa", "fa-fw", "fa-remove"], [3, "click"], [1, "dropdown-item"], [1, "fa", "fa-fw", 3, "ngClass"], ["ng-show", "phoneHover === true", 1, "fab-wrap"], ["type", "button", 1, "btn", "btn-primary", "btn-fab-md", "btn-fab-center", 3, "click"], [1, "fa", "fa-plus"]], template: function MtPhoneComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n            ");
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n                ");
        ɵngcc0.ɵɵelementStart(5, "div", 2);
        ɵngcc0.ɵɵtext(6, "\n                    ");
        ɵngcc0.ɵɵtemplate(7, MtPhoneComponent_ngb_panel_7_Template, 67, 11, "ngb-panel", 3);
        ɵngcc0.ɵɵtext(8, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(9, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(10, "\n            ");
        ɵngcc0.ɵɵtemplate(11, MtPhoneComponent_div_11_Template, 7, 0, "div", 4);
        ɵngcc0.ɵɵtext(12, "\n            ");
        ɵngcc0.ɵɵelement(13, "br");
        ɵngcc0.ɵɵtext(14, "\n            ");
        ɵngcc0.ɵɵelement(15, "br");
        ɵngcc0.ɵɵtext(16, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(17, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("formGroup", ctx.parentForm);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.phonesControls);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.canAdd);
    } }, directives: function () { return [ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.FormGroupName, ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc3.NgbPanel, ɵngcc1.FormArrayName, ɵngcc3.NgbDropdown, ɵngcc3.NgbDropdownToggle, ɵngcc3.NgbDropdownMenu, ɵngcc2.NgClass, ɵngcc1.DefaultValueAccessor, ɵngcc1.MinLengthValidator, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, MtPhoneMaskDirective]; }, encapsulation: 2 });
MtPhoneComponent.ctorParameters = () => [
    { type: FormBuilder }
];
MtPhoneComponent.propDecorators = {
    PhoneArray: [{ type: Input, args: ['PhoneArray',] }],
    PhoneTypes: [{ type: Input, args: ['PhoneTypes',] }],
    parentForm: [{ type: Input }],
    rows: [{ type: ViewChildren, args: ['input',] }],
    defaultPhoneTypeId: [{ type: Input }],
    canAdd: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtPhoneComponent, [{
        type: Component,
        args: [{
                selector: 'app-mt-phone',
                template: `
        <div class="form-group">
            <div [formGroup]="parentForm">
                <div formGroupName="phones">
                    <ngb-panel *ngFor="let phone of phonesControls; let i = index" type="info">
                        <div [formArrayName]="i" class="input-group">
                            <span class="input-group-btn">
                                <span ngbDropdown class="dropdown">
                                    <button ngbDropdownToggle type="button" class="btn btn-default btn-flat dropdown-toggle">
                                        <i class="fa fa-fw fa-{{ phoneTypeClass(phone.value.PhoneTypeId) }}"></i>
                                        <span class="caret"></span>
                                    </button>
                                    <ul ngbDropdownMenu class="dropdown-menu">
                                        <li *ngFor="let phoneType of PhoneTypes" (click)="setPhoneType(i, phoneType.Id)">
                                            <a class="dropdown-item">
                                                <i
                                                    class="fa fa-fw"
                                                    [ngClass]="{
                                                        'fa-check': phone.value.PhoneTypeId === phoneType.Id
                                                    }"
                                                ></i>
                                                <span class="fa fa-no-margin-right fa-{{ phoneTypeClass(phoneType.Id) }}"></span>&#160;
                                                {{ phoneType.Name }}</a
                                            >
                                        </li>
                                    </ul>
                                </span>
                            </span>
                            <div class="row">
                                <div
                                    class="col-md-8"
                                    style="padding-right: 0;"
                                    [ngClass]="{
                                        'has-error':
                                            parentForm.get('phones')['controls'][i].touched &&
                                            parentForm.get('phones')['controls'][i].dirty &&
                                            !parentForm.get('phones')['controls'][i].valid
                                    }"
                                >
                                    <input
                                        #input
                                        name="Phone"
                                        minlength="10"
                                        type="tel"
                                        class="form-control"
                                        id="inputPhone"
                                        formControlName="Phone"
                                        phoneMask
                                    />
                                </div>
                                <div class="col-md-4" style="padding-left: 0;">
                                    <div class="input-group" style="width: 100%">
                                        <span class="input-group-addon" id="ext-addon">Ext:</span>
                                        <input
                                            aria-describedby="ext-addon"
                                            type="tel"
                                            name="ext"
                                            class="form-control"
                                            id="inputExt"
                                            formControlName="Extension"
                                        />
                                    </div>
                                </div>
                            </div>
                            <span class="input-group-btn">
                                <button
                                    type="button"
                                    class="btn btn-default btn-flat"
                                    (click)="setPhonePref(i)"
                                    [ngClass]="{
                                        selected: phone.value.IsPrimary
                                    }"
                                >
                                    <i class="fa"></i>
                                    <i class="fa fa-fw fa-star"></i>
                                    <i class="fa"></i>
                                </button>
                            </span>
                            <span class="input-group-btn">
                                <button type="button" class="btn btn-default btn-flat" (click)="removePhone(i)">
                                    <i class="fa"></i>
                                    <i class="fa fa-fw fa-remove"></i>
                                    <i class="fa"></i>
                                </button>
                            </span>
                        </div>
                    </ngb-panel>
                </div>
            </div>
            <div *ngIf="canAdd" class="fab-wrap" ng-show="phoneHover === true">
                <button type="button" class="btn btn-primary btn-fab-md btn-fab-center" (click)="addEmptyPhone()">
                    <i class="fa fa-plus"></i>
                </button>
            </div>
            <br />
            <br />
        </div>
    `
            }]
    }], function () { return [{ type: ɵngcc1.FormBuilder }]; }, { PhoneTypes: [{
            type: Input,
            args: ['PhoneTypes']
        }], canAdd: [{
            type: Input
        }], PhoneArray: [{
            type: Input,
            args: ['PhoneArray']
        }], parentForm: [{
            type: Input
        }], rows: [{
            type: ViewChildren,
            args: ['input']
        }], defaultPhoneTypeId: [{
            type: Input
        }] }); })();

class PhonePipe {
    constructor() { }
    transform(value, args) {
        if (typeof value === 'string') {
            return format.phone(value);
        }
        if ((value === null || value === void 0 ? void 0 : value.Phone) && typeof value.Phone === 'string') {
            if ((value === null || value === void 0 ? void 0 : value.Extension) && typeof value.Extension === 'string') {
                return format.phoneWithExt(value.Phone, value.Extension);
            }
            return format.phone(value.Phone);
        }
        return '';
    }
}
PhonePipe.ɵfac = function PhonePipe_Factory(t) { return new (t || PhonePipe)(); };
PhonePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "phone", type: PhonePipe, pure: true });
PhonePipe.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PhonePipe, [{
        type: Pipe,
        args: [{
                name: 'phone'
            }]
    }], function () { return []; }, null); })();

class MtPhoneMaskDirective {
    constructor(elementRef, injector) {
        var _a;
        this.elementRef = elementRef;
        this.injector = injector;
        if (!this.config) {
            this.config = this.injector.get(MtPhoneModuleConfigToken);
        }
        this.phonePipe = new PhonePipe();
        ((_a = this.config) === null || _a === void 0 ? void 0 : _a.maskOverride) ? (this.phoneFormatter = this.config.maskOverride) : (this.phoneFormatter = this.phonePipe);
        this.el = this.elementRef.nativeElement;
    }
    ngOnInit() {
        this.el.value = this.phoneFormatter.transform(this.el.value);
    }
    onInput(value) {
        this.el.value = this.phoneFormatter.transform(value.replace(/\D/g, ''));
    }
}
MtPhoneMaskDirective.ɵfac = function MtPhoneMaskDirective_Factory(t) { return new (t || MtPhoneMaskDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
MtPhoneMaskDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MtPhoneMaskDirective, selectors: [["", "phoneMask", ""]], hostBindings: function MtPhoneMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("ngModelChange", function MtPhoneMaskDirective_ngModelChange_HostBindingHandler($event) { return ctx.onInput($event); });
    } } });
MtPhoneMaskDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Injector }
];
MtPhoneMaskDirective.propDecorators = {
    onInput: [{ type: HostListener, args: ['ngModelChange', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtPhoneMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[phoneMask]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Injector }]; }, { onInput: [{
            type: HostListener,
            args: ['ngModelChange', ['$event']]
        }] }); })();

class IsPrimaryPipe {
    constructor() { }
    transform(value, args) {
        return getPrimary(value);
    }
}
IsPrimaryPipe.ɵfac = function IsPrimaryPipe_Factory(t) { return new (t || IsPrimaryPipe)(); };
IsPrimaryPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "primary", type: IsPrimaryPipe, pure: true });
IsPrimaryPipe.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IsPrimaryPipe, [{
        type: Pipe,
        args: [{
                name: 'primary'
            }]
    }], function () { return []; }, null); })();

class MtPhoneControlModule {
}
MtPhoneControlModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MtPhoneControlModule });
MtPhoneControlModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MtPhoneControlModule_Factory(t) { return new (t || MtPhoneControlModule)(); }, imports: [[CommonModule, FormsModule, ReactiveFormsModule, NgbModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MtPhoneControlModule, { declarations: function () { return [MtPhoneComponent, MtPhoneMaskDirective, PhonePipe, IsPrimaryPipe]; }, imports: function () { return [CommonModule, FormsModule, ReactiveFormsModule, NgbModule]; }, exports: function () { return [MtPhoneComponent, MtPhoneMaskDirective, PhonePipe, IsPrimaryPipe]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtPhoneControlModule, [{
        type: NgModule,
        args: [{
                declarations: [MtPhoneComponent, MtPhoneMaskDirective, PhonePipe, IsPrimaryPipe],
                exports: [MtPhoneComponent, MtPhoneMaskDirective, PhonePipe, IsPrimaryPipe],
                imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbModule]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { DefaultPhoneTypes, IsPrimaryPipe, MtPhoneComponent, MtPhoneControlModule, MtPhoneMaskDirective, MtPhoneModuleConfigToken, PhonePipe };

//# sourceMappingURL=mt-ng2-phone-control.js.map